export var HEADER_META_DATA_API = "/header/meta.json";
export var HEADER_MINICART_API = "/header/cart.json";
export var HEADER_MINICART_REMOVE_ITEM_API = "/header/remove/cart.json";
export var HEADER_MY_ACCOUNT_API = "/header/account.json";
export var HEADER_WISHLIST_API = "/header/wishlist.json";
export var HEADER_WISHLIST_REMOVE_ITEM_API = "/header/remove/wishlist.json";
export var HEADER_LOYALTY_API = "/header/loyalty.json";
export var HEADER_COUPONS_API = "/header/coupons.json";
export var HEADER_XMAS_HAT = "https://s.catch.com.au/static/catch/images/xmas-hat-cap.png";
export var HEADER_XMAS_POMPOM = "https://s.catch.com.au/static/catch/images/xmas-hat-pompom.png";
export var HEADER_XMAS_TILE = "https://s.catch.com.au/static/catch/images/xmas-tile.png";
export var DEFAULT_FREE_TRIAL_DAYS = 30;
export var ONEPASS_MONTHLY_PRICE = 400;
export var ONEPASS_YEARLY_PRICE = 4000;